(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("SelectFunctionsDialogController", SelectFunctionsDialogController);

    function SelectFunctionsDialogController($uibModalInstance) {
        var vm = this;

        vm.cancel = cancel;
        vm.ok = ok;

        vm.remove = remove;
        vm.functionSelected = functionSelected;
        vm.functions = [];

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
        function ok() {
            $uibModalInstance.close(vm.functions);
        }

        function remove(item) {
            vm.functions.splice(vm.functions.indexOf(item), 1);
        }

        function functionSelected(item) {
            if (_.find(vm.functions, function (f) { return f.id === item.roleId; })) {
                return;
            }

            vm.functions.push({
                id: item.roleId,
                name: item.roleName
            });
        }
    }
})();